import { useState } from "react";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import KillSwitchConfirmDialog from "@/components/marketing/KillSwitchConfirmDialog";
import { useKillSwitch } from "@/hooks/sms/useKillSwitch";

/**
 * Compact "Stop all marketing" quick action for pages where an owner might
 * be about to launch a campaign — shares `useKillSwitch` and
 * `KillSwitchConfirmDialog` with the Emergency stop card in the Settings
 * header, so there is only ever one kill-switch implementation. Renders
 * nothing once the kill switch is already on (KillSwitchBanner covers that
 * state).
 */
const StopMarketingButton = () => {
  const { settings, checked, setKillSwitch } = useKillSwitch();
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!settings || checked) return null;

  const stopAll = () => {
    setKillSwitch(true);
    setDialogOpen(false);
  };

  return (
    <>
      <Button
        type="button"
        variant="outline"
        className="h-11 gap-2 border-status-danger/40 text-status-danger hover:bg-status-danger/10 hover:text-status-danger"
        onClick={() => setDialogOpen(true)}
      >
        <ShieldAlert className="h-4 w-4" />
        Stop all marketing
      </Button>

      <KillSwitchConfirmDialog open={dialogOpen} onOpenChange={setDialogOpen} onConfirm={stopAll} />
    </>
  );
};

export default StopMarketingButton;
